import BasicPortInformationForm from "../Components/Estimativa/BasicPortInformationForm";
import { SessionCheck } from "../Components/Common/Helper";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";


export default function BasicPortInformation() {
  const location = useLocation();
  const navigate = useNavigate();
  const tipoOperacaoDTO = location.state;
  const sessionCheck = async () => { return await SessionCheck() };
  const [sessionChecked, setSessionChecked] = useState(false);

  useEffect(() => {
    sessionCheck().then(value => {
      if (value){
        setSessionChecked(true);
      }
      else{
        navigate('/StartSimulation')
      }
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {sessionChecked &&
        <div className="items-center">
          <div className="container mx-auto pt-4 pb-4 lg:px-6  bg-white">
            <section>
              <div className="flex flex-wrap items-start justify-center">
                <div className="w-full shrink-0 grow-0 basis-auto  lg:w-5/6 xl:w-4/6 px-3 ">
                  <h2 className="text-3xl font-bold">2. Defina as</h2>
                  <h2 className="text-orange-600 mb-1 text-3xl font-bold">informações básicas:</h2>
                  <p className="sm:max-w-md"> <span className="text-gray-500">
                  Dados da operação portuária a ser realizada. Para efeitos desta simulação, será considerada operação em horário comercial. Os valores reais podem variar na operação real devido ao dia e horário da execução do serviço.</span>
                  </p>
                </div>
                <BasicPortInformationForm tipoOperacaoDTO={tipoOperacaoDTO} />
              </div>
            </section>
          </div>
        </div>
      }
    </motion.div>
  );
}